import { CommonModule, DecimalPipe } from "@angular/common";
import { RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule, NgbToastModule } from "@ng-bootstrap/ng-bootstrap";
import { SwiperModule } from "swiper/angular";

// Components
import { BreadcrumbComponent } from "./components/breadcrumb/breadcrumb.component";
import { FeatherIconsComponent } from "./components/feather-icons/feather-icons.component";
import { FooterComponent } from "./components/footer/footer.component";
import { HeaderComponent } from "./components/header/header.component";
import { ContentComponent } from "./components/layout/content/content.component";
import { FullComponent } from "./components/layout/full/full.component";
import { LoaderComponent } from "./components/loader/loader.component";
import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { TapToTopComponent } from "./components/tap-to-top/tap-to-top.component";

// Header Elements Components
import { SearchComponent } from "./components/header/elements/search/search.component";
import { LanguagesComponent } from "./components/header/elements/languages/languages.component";
import { NotificationComponent } from "./components/header/elements/notification/notification.component";
import { BookmarkComponent } from "./components/header/elements/bookmark/bookmark.component";
import { CartComponent } from "./components/header/elements/cart/cart.component";
import { MessageBoxComponent } from "./components/header/elements/message-box/message-box.component";
import { MyAccountComponent } from "./components/header/elements/my-account/my-account.component";

// Services
import { LayoutService } from "./services/layout.service";
import { NavService } from "./services/nav.service";

// Other Components
import { SvgIconComponent } from "./components/svg-icon/svg-icon.component";
import { SwiperComponent } from "./components/header/elements/swiper/swiper.component";

// Widgets
import { ActivityComponent } from "./widgets/activity/activity.component";
import { PerformanceGrowthComponent } from "./widgets/performance-growth/performance-growth.component";
import { BudgetBlanaceComponent } from "./widgets/budget-balance/budget-balance.component";
import { OrdersComponent } from "./widgets/budget-balance/orders/orders.component";
import { ProfitComponent } from "./widgets/budget-balance/profit/profit.component";
import { OverallBalanceComponent } from "./widgets/overall-balance/overall-balance.component";
import { PaperNoteComponent } from "./widgets/paper-note/paper-note.component";
import { StatusBoxComponent } from "./widgets/status-box/status-box.component";
import { PurchaseAccountComponent } from "./widgets/purchase-account/purchase-account.component";
import {  RecentHappeningsComponent } from "./widgets/recent-happenings/recent-happenings.component";
import { RecentEvaluationsComponent } from "./widgets/recent-evaluations/recent-evaluations.component";
import { StatusComponent } from "./widgets/status/status.component";
import { TimelineComponent } from "./widgets/timeline/timeline.component";
import { TotalContractsComponent } from "./widgets/total-contracts/total-contracts.component";
import { WelcomeComponent } from "./widgets/welcome/welcome.component";
import { WidgetsComponent } from "./widgets/widgets.component";
import { FeedbackComponent } from "./components/feedback/feedback.component";
import { NgApexchartsModule } from "ng-apexcharts";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { ChartComponent } from "./widgets/chart/chart.component";
import { GeneralComponent } from "./widgets/general/general.component";
import { CarouselModule } from "ngx-owl-carousel-o";
import { ChartistModule } from "ng-chartist";
import { NgChartsModule } from "ng2-charts";
import { FollowersGrowthComponent } from "./widgets/general/followers-growth/followers-growth.component";
import { VisitorsComponent } from "./widgets/general/visitors/visitors.component";
import { CommonTopChartComponent } from "./widgets/chart/common-top-chart/common-top-chart.component";
import { MonthlyHistoryComponent } from "./widgets/chart/monthly-history/monthly-history.component";
import { UsesComponent } from "./widgets/chart/uses/uses.component";
import { MonthlySalesComponent } from "./widgets/chart/monthly-sales/monthly-sales.component";
import { OrderStatus2Component } from "./widgets/chart/order-status2/order-status2.component";
import { FinanceComponent } from "./widgets/chart/finance/finance.component";
import { StockMarketComponent } from "./widgets/chart/stock-market/stock-market.component";
import { CryptoAnnotationsComponent } from "./widgets/chart/crypto-annotations/crypto-annotations.component";
import { CryptocurrencyPricesComponent } from "./widgets/chart/cryptocurrency-prices/cryptocurrency-prices.component";
import { TurnOverComponent } from "./widgets/chart/turn-over/turn-over.component";
import { LiveProductsComponent } from "./widgets/chart/live-products/live-products.component";
import { OrderStatusComponent } from "./widgets/chart/order-status/order-status.component";
import { SkillStatusComponent } from "./widgets/chart/skill-status/skill-status.component";
import { WidgestCoinsComponent } from './widgets/general/widgest-coins/widgest-coins.component';
import { TotalUserswidgetsComponent } from './widgets/general/total-userswidgets/total-userswidgets.component';

// crypto
import { CryptoComponent } from './widgets/crypto/crypto.component';
import { CryptoLeftContentComponent } from './widgets/crypto/crypto-left-content/crypto-left-content.component';
import { CryptoMiddleContentComponent } from './widgets/crypto/crypto-middle-content/crypto-middle-content.component';
import { CryptoRightContentComponent } from './widgets/crypto/crypto-right-content/crypto-right-content.component';
import { AverageComponent } from './widgets/crypto/crypto-left-content/average/average.component';
import { TransactionsComponent } from './widgets/crypto/crypto-left-content/transactions/transactions.component';
import { CoinComponent } from './widgets/crypto/crypto-middle-content/coin/coin.component';
import { MarketGraphComponent } from './widgets/crypto/crypto-middle-content/market-graph/market-graph.component';
import { CurrenciesComponent } from './widgets/crypto/crypto-middle-content/currencies/currencies.component';
import { BuyCoinsComponent } from './widgets/crypto/crypto-middle-content/buy-coins/buy-coins.component';
import { SellCoinsComponent } from './widgets/crypto/crypto-middle-content/sell-coins/sell-coins.component';
import { BalanceProfileComponent } from './widgets/crypto/crypto-right-content/balance-profile/balance-profile.component';
import { PortfolioComponent } from './widgets/crypto/crypto-right-content/portfolio/portfolio.component';
import { ActivitiesComponent } from './widgets/crypto/crypto-right-content/activities/activities.component';

import { LeftContentComponent } from ".//widgets/ecommerce/left-content/left-content.component";
import { RightTopCategoriesComponent } from ".//widgets/ecommerce/right-top-categories/right-top-categories.component";
import { OrderBoardComponent } from ".//widgets/ecommerce/left-content/order-board/order-board.component";
import { ValuableCustomerComponent } from ".//widgets/ecommerce/left-content/valuable-customer/valuable-customer.component";
import { MonthlyOrderComponent } from ".//widgets/ecommerce/left-content/monthly-order/monthly-order.component";
import { MonthlyProfitsComponent } from ".//widgets/ecommerce/left-content/monthly-profits/monthly-profits.component";
import { OrderOverviewComponent } from ".//widgets/ecommerce/left-content/order-overview/order-overview.component";
import { DiscoverProComponent } from ".//widgets/ecommerce/left-content/discover-pro/discover-pro.component";
import { RecentOrdersTableComponent } from ".//widgets/ecommerce/left-content/recent-orders-table/recent-orders-table.component";
import { ProductTableComponent } from './/widgets/ecommerce/left-content/recent-orders-table/product-table/product-table.component';
import { RightChartDataComponent } from './/widgets/ecommerce/left-content/order-overview/right-chart-data/right-chart-data.component';
import { SaleStatusComponent } from './widgets/ecommerce/left-content/order-board/sale-status/sale-status.component';

import { SocialComponent } from './widgets/social/social.component';
import { SocialUserProfileComponent } from './widgets/social/social-user-profile/social-user-profile.component';
import { MobileApplicationComponent } from './widgets/social/mobile-application/mobile-application.component';
import { SocialMediaComponent } from './widgets/social/social-media/social-media.component';
import { SocialMediaChartComponent } from './widgets/social/social-media/social-media-chart/social-media-chart.component';
import { SubscribersComponent } from './widgets/social/social-media/subscribers/subscribers.component';
import { ClicksChartsComponent } from './widgets/social/social-media/clicks-charts/clicks-charts.component';
import { FollowerGenderComponent } from './widgets/social/follower-gender/follower-gender.component';
import { CampaignComponent } from './widgets/social/campaign/campaign.component';
import { AllCampaignsComponent } from './widgets/social/all-campaigns/all-campaigns.component';
import { ViewsComponent } from './widgets/social/views/views.component';

import { OnlineCourseComponent } from './widgets/online-course/online-course.component';
import { HelloNameComponent } from './widgets/online-course/hello-name/hello-name.component';
import { TodayProgressComponent } from './widgets/online-course/today-progress/today-progress.component';
import { MoreDetailsComponent } from './widgets/online-course/more-details/more-details.component';
import { CalendarComponent } from './widgets/online-course/calendar/calendar.component';
import { LearningOverviewComponent } from './widgets/online-course/learning-overview/learning-overview.component';
import { ActivityHoursComponent } from './widgets/online-course/activity-hours/activity-hours.component';
import { UpcomingEventsComponent } from './widgets/online-course/upcoming-events/upcoming-events.component';
import { UpcomingScheduleComponent } from './widgets/online-course/upcoming-schedule/upcoming-schedule.component';
import { MyCourseComponent } from './widgets/online-course/my-course/my-course.component';
import { ActiveLessonsComponent } from './widgets/online-course/active-lessons/active-lessons.component';
import { CoursesComponent } from './widgets/online-course/hello-name/courses/courses.component';

import { ValidationMessagesComponent } from './components/validation-messages/validation-messages.component';
import { TranslateModule } from "@ngx-translate/core";

import { ImportExcelComponent } from './components/import-excel/import-excel.component';
import { JobCardComponent } from './components/job-card/job-card.component'

import { TruncatePipe } from '../pipes/truncate.pipe';

import { ToastContainerComponent } from './components/toast/toast-container/toast-container.component'


// Recruitments
import { CandidatesComponent } from './components/recruitments/candidates/candidates.component';
import { CandidateFormComponent } from './components/recruitments/candidates/form/form.component';
import { ListComponent } from './components/recruitments/list/list.component';
import { NgSelectModule } from "@ng-select/ng-select";
import { PermissionPipe } from "../pipes/permission.pipe";
import { ModuleFilterPipe } from "../pipes/module-filter.pipe";
import { TooltipComponent } from "./components/tooltip/tooltip.component";
import { AssessmentKpisComponent } from "./components/assessment-kpis/kpis.component";
import { HighPotentialComponent } from "./components/high-potential/high-potential.component";
import { SuccessionModalComponent } from "./components/employees/succession-modal/succession-modal.component";
import { SkillsModalComponent } from "./components/employees/skills-modal/skills-modal.component";

@NgModule({
  declarations: [
    // Layout Components
    ToastContainerComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    ContentComponent,
    BreadcrumbComponent,
    FeatherIconsComponent,
    FullComponent,
    LoaderComponent,
    TapToTopComponent,
    // Header Elements Components
    SearchComponent,
    LanguagesComponent,
    NotificationComponent,
    BookmarkComponent,
    CartComponent,
    MessageBoxComponent,
    MyAccountComponent,
    // Other Components
    SvgIconComponent,
    SwiperComponent,
    // Widgets
    ActivityComponent,
    PerformanceGrowthComponent,
    BudgetBlanaceComponent,
    OrdersComponent,
    ProfitComponent,
    OverallBalanceComponent,
    PaperNoteComponent,
    StatusBoxComponent,
    PurchaseAccountComponent,
    RecentHappeningsComponent,
    RecentEvaluationsComponent,
    StatusComponent,
    TimelineComponent,
    TotalContractsComponent,
    WelcomeComponent,
    WidgetsComponent,
    FeedbackComponent,
    ValidationMessagesComponent,

    ChartComponent,
    GeneralComponent,
    FollowersGrowthComponent,
    VisitorsComponent,
    CommonTopChartComponent,
    MonthlyHistoryComponent,
    UsesComponent,
    MonthlySalesComponent,
    OrderStatus2Component,
    FinanceComponent,
    StockMarketComponent,
    CryptoAnnotationsComponent,
    CryptocurrencyPricesComponent,
    TurnOverComponent,
    LiveProductsComponent,
    OrderStatusComponent,
    SkillStatusComponent,
    WidgestCoinsComponent,
    TotalUserswidgetsComponent,

    CryptoComponent,
    CryptoLeftContentComponent,
    CryptoMiddleContentComponent,
    CryptoRightContentComponent,
    AverageComponent,TransactionsComponent,
    CoinComponent,
    MarketGraphComponent,
    CurrenciesComponent,
    BuyCoinsComponent,
    SellCoinsComponent,
    BalanceProfileComponent,
    PortfolioComponent,
    ActivitiesComponent,

    LeftContentComponent, 
    RightTopCategoriesComponent,
    OrderBoardComponent,
    ValuableCustomerComponent,
    MonthlyOrderComponent,
    MonthlyProfitsComponent,
    OrderOverviewComponent,
    DiscoverProComponent,
    RecentOrdersTableComponent,
    ProductTableComponent,
    RightChartDataComponent,
    SaleStatusComponent,

    SocialComponent,
    SocialUserProfileComponent,
    MobileApplicationComponent,
    SocialMediaComponent,
    SocialMediaChartComponent,
    SubscribersComponent,
    ClicksChartsComponent,
    FollowerGenderComponent,
    CampaignComponent,
    AllCampaignsComponent,
    ViewsComponent,

    OnlineCourseComponent,
    HelloNameComponent,
    TodayProgressComponent,
    MoreDetailsComponent,
    CalendarComponent,
    LearningOverviewComponent,
    ActivityHoursComponent,
    UpcomingEventsComponent,
    UpcomingScheduleComponent,
    MyCourseComponent,
    ActiveLessonsComponent,
    CoursesComponent,

    ImportExcelComponent,
    JobCardComponent,
    TruncatePipe,
    PermissionPipe,
    ModuleFilterPipe,

    // Recruitments
    CandidatesComponent,
    ListComponent,
    CandidateFormComponent,

    TooltipComponent,
    AssessmentKpisComponent,
    HighPotentialComponent,

    // Employees
    SuccessionModalComponent,
    SkillsModalComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgSelectModule,
    NgApexchartsModule,
    FontAwesomeModule,
    TranslateModule,
    SwiperModule,
    NgbToastModule
  ],
  providers: [NavService, LayoutService, DecimalPipe],
  exports: [
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    LoaderComponent,
    BreadcrumbComponent,
    FeatherIconsComponent,
    TapToTopComponent,
    SvgIconComponent,
    SwiperModule,
    // Exporting other components
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    ContentComponent,
    FullComponent,
    SearchComponent,
    LanguagesComponent,
    NotificationComponent,
    BookmarkComponent,
    CartComponent,
    MessageBoxComponent,
    MyAccountComponent,
    ActivityComponent,
    PerformanceGrowthComponent,
    BudgetBlanaceComponent,
    OrdersComponent,
    ProfitComponent,
    OverallBalanceComponent,
    PaperNoteComponent,
    StatusBoxComponent,
    PurchaseAccountComponent,
    RecentHappeningsComponent,
    RecentEvaluationsComponent,
    StatusComponent,
    TimelineComponent,
    TotalContractsComponent,
    WelcomeComponent,
    WidgetsComponent,

    ChartComponent,
    GeneralComponent,
    FollowersGrowthComponent,
    VisitorsComponent,
    CommonTopChartComponent,
    MonthlyHistoryComponent,
    UsesComponent,
    MonthlySalesComponent,
    OrderStatus2Component,
    FinanceComponent,
    StockMarketComponent,
    CryptoAnnotationsComponent,
    CryptocurrencyPricesComponent,
    TurnOverComponent,
    LiveProductsComponent,
    OrderStatusComponent,
    SkillStatusComponent,
    WidgestCoinsComponent,
    TotalUserswidgetsComponent,

    CryptoComponent,
    CryptoLeftContentComponent,
    CryptoMiddleContentComponent,
    CryptoRightContentComponent,
    AverageComponent,TransactionsComponent,
    CoinComponent,
    MarketGraphComponent,
    CurrenciesComponent,
    BuyCoinsComponent,
    SellCoinsComponent,
    BalanceProfileComponent,
    PortfolioComponent,
    ActivitiesComponent,

    LeftContentComponent, 
    RightTopCategoriesComponent,
    OrderBoardComponent,
    ValuableCustomerComponent,
    MonthlyOrderComponent,
    MonthlyProfitsComponent,
    OrderOverviewComponent,
    DiscoverProComponent,
    RecentOrdersTableComponent,
    ProductTableComponent,
    RightChartDataComponent,
    SaleStatusComponent,

    SocialComponent,
    SocialUserProfileComponent,
    MobileApplicationComponent,
    SocialMediaComponent,
    SocialMediaChartComponent,
    SubscribersComponent,
    ClicksChartsComponent,
    FollowerGenderComponent,
    CampaignComponent,
    AllCampaignsComponent,
    ViewsComponent,

    OnlineCourseComponent,
    HelloNameComponent,
    TodayProgressComponent,
    MoreDetailsComponent,
    CalendarComponent,
    LearningOverviewComponent,
    ActivityHoursComponent,
    UpcomingEventsComponent,
    UpcomingScheduleComponent,
    MyCourseComponent,
    ActiveLessonsComponent,
    CoursesComponent,

    ValidationMessagesComponent,

    ImportExcelComponent,
    JobCardComponent,

    TruncatePipe,
    PermissionPipe,
    ModuleFilterPipe,
    ToastContainerComponent,

    // Recruitments
    CandidatesComponent,
    ListComponent,
    CandidateFormComponent,

    TooltipComponent,
    AssessmentKpisComponent,
    HighPotentialComponent,

    // Employees
    SuccessionModalComponent,
    SkillsModalComponent
  ]
})
export class SharedModule {}
